<template>
    <div>
        <rkm-modal
            large
            ref="RkmModal"
            title="Residentes"
        >

            <rkm-table
                :fields="fields.tables.residentes"
                :items="items"
                sort-by="nome"
            >

                <template v-slot:cell(nome)="{ item }">
                    {{ item.nome }}
                    <template v-if="item.nomeSocial">
                        <b>({{ item.nomeSocial }})</b>
                    </template>
                </template>

                <template v-slot:cell(cns)="{ item }">
                    {{ formataCns(item) }}
                </template>

                    <template v-slot:cell(actions)="{ item }">

                        <rkm-button
                            v-if="origem == 'atendimento'"
                            @click.stop="$refs.Modal.open(item)"
                            color="primary"
                            title="Abrir modal"
                            small
                        >
                            <rkm-icon icon="search" />
                        </rkm-button>

                        <rkm-button
                            v-else
                            @click.stop="search(item)"
                            :disabled="item.obitoEm ? true : false"
                            color="primary"
                            title="Visualizar"
                            small
                        >
                            <rkm-icon icon="search" />
                        </rkm-button>
                    </template>
            </rkm-table>

            <template
                v-slot:footer
            >
                <rkm-button
                    @click="handleCancel"
                >
                    Fechar
                </rkm-button>
            </template>
        </rkm-modal>

        <Modal
            ref="Modal"
            origem="atendimento"
            :data="data"
        />
    </div>
</template>

<script>
import { mapActions } from 'vuex'


import Modal from './components/residentes/Modal.vue'

// Mixins.
import { repository, stringCase, object, formats } from '@/mixins'

export default {
    components: {
        Modal
    },
    computed: {
        fields() {
            return {
                tables: {
                    residentes: [
                        { key: 'nome', label: 'Nome',  sortable: true },
                        { key: 'cns', label: 'CNS', class: 'col-min text-center', sortable: true },
                        { key: 'prontuario', label: 'Prontuário', class: 'col-min text-center', sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min' },
                    ],
                },
            }
        },
    },
    created() {
        this.repositories = {
            visitaDomiciliar: this.getConectaSusRepository('atencaoBasica.visitaDomiciliar'),
        }
    },
    data: () => ({
        items: [],
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item) {

            if (this.origem == 'atendimento') {
                this.items = this.residentes
            }

            this.getResidentes(item)
            this.$refs.RkmModal.show()
        },
        getResidentes(item) {

            this.setLoading()

            const request = {
                pacienteId: item.id,
            }

            this.repositories.visitaDomiciliar.getResidentes(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.items = Object.assign(response.data)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleCancel() {
            this.$emit('closeModal')
            this.$refs.RkmModal.hide()
        },
        formataCns(item){
            return item.cns ? this.formatCns(item.cns) : '-'
        },
        search(item) {

            this.$router.push({ name: 'atencao-basica-visita-domiciliar-list', params: { id: item.id } })
        }
    },
    mixins: [ repository, stringCase, object, formats ],
    props: {
        data: { type: Object, required: false },
        residentes: { type: Array, required: false },
        origem: { type: String },
    }
}
</script>

<style scoped>
.warning {
    color: var(--warning);
}
</style>